"use client";


import SectionPage from "@/components/common/section-page";

import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, } from "@/components/ui/breadcrumb"
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import IllustratedTitleCard from "@/components/common/illustrated-title-card";
import { Link } from "react-router-dom";
import CardImageZoomIn from "@/components/common/card-image-zoom-in";
import ImageGallery from "@/components/common/image-gallery";
import EventCard from "@/components/common/event-card";

const evenements = [
    {
        title: "Rallye",
        image: "/images/evenements/Rallye-BANDAMA.jpg",
    },
    {
        title: "MASSA",
        image: "/images/evenements/massa.png"
    },
    {
        title: "FEMUA",
        image: "/images/evenements/FEMUA.jpg"
    },
    {
        title: "Paquinou",
        image: "/images/evenements/Paquinou-copie-scaled.jpg"
    },
    {
        title: "Tournois de Golf de la Pentecôte",
        image: "/images/evenements/Tournois-de-Golf-Pentecote.jpg"
    },
    {
        title: "Tchin Dan Festival",
        image: "/images/evenements/Tchin-Dan-Festival-copie-scaled.jpg"
    },
    {
        title: "Festival des Grillades",
        image: "/images/evenements/Festival-des-Grillades.jpg"
    },
    {
        title: "Adeye Kessiè",
        image: "/images/evenements/ADAYE-Kessie.jpg"
    },
    {
        title: "Abissa",
        image: "/images/evenements/Abissa-copie.jpg"
    },
    {
        title: "Tonkpi Nihidaley",
        image: "/images/evenements/Tonkpi-Nihidaley.jpg"
    },
];

export default function Home() {

    return (
        <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
            <CardTitle title={"Agenda"} backgroundImgSrc={"/images/card-title/agenda.jpg"} />


            <SectionPage sectionType="2xl">
                <div className={"flex justify-between items-center"}>
                    <Breadcrumb>
                        <BreadcrumbList>
                            <BreadcrumbItem>
                                <BreadcrumbLink href={"/"}>Agenda</BreadcrumbLink>
                            </BreadcrumbItem>
                        </BreadcrumbList>
                    </Breadcrumb>

                </div>
            </SectionPage>

            {/* Evenements */}
            <SectionPage sectionType="2xl">
                {/* Evenements 2025 */}

                <AwesomeCard title={"Evènements 2025"} className={"bg-white"} titleClassName={"text-bleu-marine"}>
                    <div className={'mt-8'}>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8">
                            <EventCard
                                id={"0"}
                                title={"🧡🤍💚🌍 FIACT 2025 – Grand-Bassam ✨"}
                                date={"27 oct. – 7 jan. 2026"}
                                image={"/images/agenda/EVENEMENT-FIACT.jpeg"}
                                location={"Grand-Bassam, Côte d'Ivoire"}
                                description={"La Foire Internationale de l’Artisanat, de la Culture et du Tourisme (FIACT) revient pour sa 5ᵉ érème du 27 octobre 2025 au 07 janvier 2026 au Centre Artisanal de Grand-Bassam. 😍 Vivez une expérience unique au cœur de cette ville patrimoine, entre créativité, savoir-faire et traditions ! 🖐🏾🎭\n\nAu programme :\n✨ Expositions d’artisanat et d’arts contemporains\n🎶 Prestations artistiques et culturelles\n🖼️ Découvertes et circuits touristiques dans la ville musée\n🎁 Souvenirs et objets d’art faits main"}
                                tags={["FIACT", "Artisanat", "Culture", "Tourisme", "SudComoe", "CôtedIvoire", "GrandBassam", "CIV", "MadeInCI", "VillePatrimoine"]}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            
                            <EventCard
                                id={"0"}
                                title={"🎉🇨🇮 Sahoua Festival 5 – M’Batto 🎭"}
                                date={"28 – 30 oct. 2025"}
                                image={"/images/agenda/EVENEMENT-SAHOUA.jpeg"}
                                location={"M’Batto, Moronou, Côte d'Ivoire"}
                                description={"Du 28 au 30 octobre 2025, venez célébrer la culture sahoua à l’Espace Gravier, M’Batto ! ✨\n\nSous le thème : « Art & Culture, vecteurs de cohésion sociale et de développement local »\n\nAu programme :\n✨ Danses traditionnelles | 🍲 Cuisine & beauté | 🧺 Exposition du terroir\n🎶 Concerts | 🏞️ Visites touristiques | 💃🏾 Parade et animations\n\n📞 Infos : 0757411909 / 0507870735\n\n#SahouaFestival #Mbatto #Moronou #CultureIvoirienne #TourismeCI #FestivalCulturel #ArtEtCulture #CôtedIvoireTourisme"}
                                tags={["SahouaFestival", "Mbatto", "Moronou", "CultureIvoirienne", "TourismeCI", "FestivalCulturel", "ArtEtCulture", "CôtedIvoireTourisme"]}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            
                            <EventCard
                                id={"0"}
                                title={"Africa Foto Fair 2025 – Grand-Bassam, Côte d’Ivoire"}
                                date={"12 nov. – 7 déc. 2025"}
                                image={"/images/agenda/africa-foto-fair-2025.jpg"}
                                location={"Grand-Bassam, Côte d'Ivoire"}
                                description={"Festival mettant à l’honneur les talents africains de la photographie : expositions, conférences et ateliers."}
                                tags={["AfricaFotoFair", "CôtedIvoireTourisme", "PhotographieAfricaine", "GrandBassam", "CultureCI", "ArtEtCréation"]}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                            <EventCard
                                id={"1"}
                                title={"DAVIDO – 5IVE TOUR AFRICA – Abidjan"}
                                date={"Vendredi 29 novembre 2025"}
                                image={"/images/agenda/davido-concert.jpg"}
                                location={"Parc des Expositions, Abidjan"}
                                description={"Concert géant du roi de l’Afrobeat, Davido. Infos & réservations : 07 67 08 00 00 | Soutenu par Côte d’Ivoire Tourisme"}
                                tags={["Davido", "5iveTourAfrica", "AbidjanVibes", "CotedIvoireTourisme", "ConcertExceptionnel", "Afrobeat"]}
                                variant={"outline"}
                                bgColor={"secondary"}
                                className="h-full"
                            />
                        </div>
                    </div>
                </AwesomeCard>
            </SectionPage>

            <SectionPage sectionType="2xl">
                {/* Evenements 2023 */}
                <AwesomeCard title={"Evènements 2023"} className={"bg-white"} titleClassName={"text-bleu-marine"}>
                    <div className={'mt-8'}>
                        <ImageGallery images={[
                            {
                                src: "/images/agenda/JMT-2023.jpg",
                                alt: "JMT 2023",
                                width: 1000,
                                height: 1000
                            },
                            {
                                src: "/images/agenda/ABISSA-2023.jpg",
                                alt: "ABISSA 2023",
                                width: 1000,
                                height: 1000
                            }
                        ]} gridClassName={"grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-12"} />
                    </div>
                </AwesomeCard>
            </SectionPage>

            {/* Agenda institutionnel */}
            <SectionPage sectionType="2xl">
                <AwesomeCard title={"Agenda institutionnel"} className={"bg-white"} titleClassName={"text-bleu-marine"}>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-12">
                        <IllustratedTitleCard title={"SITA"} description={"Salon international du Tourisme d'Abidjan"}
                            imageSrc={"/images/agenda/sita.gif"} alt={"JMT 2023"} width={199} height={172} />
                        <IllustratedTitleCard title={"JMT"} description={"Journée Mondiale du Tourisme"}
                            imageSrc={"/images/agenda/jmt-2021.png"} alt={"JMT 2023"} width={1024} height={576} />
                        <IllustratedTitleCard title={"Forum"} description={"Côte d'Ivoire - Destination Touristique"}
                            imageSrc={"/images/agenda/logo-forum.jpg"} alt={"JMT 2023"} width={1024} height={724} />
                    </div>
                </AwesomeCard>
            </SectionPage>

            {/*Agenda evenementiel*/}
            <SectionPage sectionType="2xl">
                <AwesomeCard title={"Agenda Evénementiel"} className={"bg-white"} titleClassName={"text-bleu-marine"}>
                    <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-2 mt-4">
                        {evenements.map((evenement, index) => {
                            return <Link to={"#"} key={index} className={"cursor-pointer"}>
                                <CardImageZoomIn image={evenement.image} title={evenement.title} className={"h-[200px]"} />
                            </Link>
                        })}
                    </div>
                </AwesomeCard>
            </SectionPage>
        </div>
    );
}
